import {TABLE_SIZE_L, TABLE_SIZE_M} from "../../offerte/OfferteHelper";

export const headCells = [
    {
        id: "descrizione-servizio",
        text: "Descrizione Servizio",
        width: TABLE_SIZE_L
    },
    // {
    //     id: "canone-unitario",
    //     text: "Canone Unitario",
    //     width: TABLE_SIZE_M
    // }
]